<template>
    <IOdometer :value="hasTriggered ? +value : +initialValue" :format="format" class="iOdometer" />
</template>

<script>
    import IOdometer from './Odometer.vue';
    import 'odometer/themes/odometer-theme-default.css';

    export default {
        name: 'NumberAnimation',
        components: {
            IOdometer,
        },
        props: {
            value: {
                type: String,
                required: true,
            },
            format: {
                // https://github.hubspot.com/odometer/#format
                type: String,
                default: '(.ddd),dd',
            },
        },
        data() {
            return {
                initialValue: '0',
                hasTriggered: false,
            };
        },
        created() {
            this.initialValue = this.initialValue.repeat(this.value.length);
            window.addEventListener('scroll', this.onWindowScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.onWindowScroll);
        },
        methods: {
            onWindowScroll() {
                const isElementInViewport = this.checkIfElementIsInViewport();
                if (isElementInViewport && !this.hasTriggered) {
                    this.hasTriggered = true;
                }
            },
            checkIfElementIsInViewport() {
                const rect = this.$el.getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },
        },
    };
</script>
